import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';

import Hr from 'LocalGluons/components/Hr';
import sectionListStyles from '../../SectionList.jss';

const SectionListHeader = ({ title, headerStyle, itemDividerStyle = {} }) => (
    <View style={sectionListStyles.item}>
        <Text style={[sectionListStyles.header, headerStyle]}>{title}</Text>
        <Hr />
    </View>
);

SectionListHeader.defaultProps = {
    headerStyle: {}
};

SectionListHeader.propTypes = {
    title: PropTypes.string.isRequired
    // headerStyle: ViewPropTypes.style
};

export default SectionListHeader;
